// @ts-nocheck
import * as React from 'react';
import DOMPurify from 'dompurify';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

export default function NoticiasProcess({notices,loading}) {
    const [activeStep, setActiveStep] = React.useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <Box>
            {loading ? <div>Cargando..</div> : <><Stepper activeStep={activeStep} orientation="vertical">
                {notices.length ? notices.map((step, index) => (
                    <Step key={step.titulo}>
                        <StepLabel
                        >
                            <Box sx={{ "&:hover": {
                                cursor: 'pointer',
                            }}} onClick={() => setActiveStep(index)}>{step.titulo} </Box>
                        </StepLabel>
                        <StepContent>
                            <Typography><p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(step.contenido)}}></p></Typography>
                            <Box sx={{mb: 2}}>
                                <div>
                                    <Button
                                        variant="contained"
                                        onClick={handleNext}
                                        sx={{mt: 1, mr: 1}}
                                    >
                                        {index === notices.length - 1 ? 'Terminar' : 'Continuar'}
                                    </Button>
                                    <Button
                                        disabled={index === 0}
                                        onClick={handleBack}
                                        sx={{mt: 1, mr: 1}}
                                    >
                                        Volver
                                    </Button>
                                </div>
                            </Box>
                        </StepContent>
                    </Step>
                )) : <div style={{ textAlign: 'center' }}>No hay noticias</div>}
            </Stepper>
            {activeStep === notices.length && (
                <Paper square elevation={0} sx={{p: 3}}>
            <Chip label='¡Estas al día!' color='primary'/>
            <br/>
        </Paper>
    )
            }</>
            }
        </Box>
    );
}